import cn from "classnames";
import { Select } from "components/shared/form";
import Invite from "components/shared/invite";
import TabTemplate from "components/shared/profile/tab";
import { userStatesEnum } from "helpers/enums/userStates";
import React from "react";
import { NavLink, Redirect, Route, Switch } from "react-router-dom";
import { invite } from "sources/profile/participants";
import List from "./list";

const lists = [
    { label: "Приглашения", value: "invited" },
    { label: "Участники", value: "members" },
    { label: "Заблокированные", value: "blocked" },
];

const pathnames = lists.map((item) => item.value);

export default class AccessControlTab extends TabTemplate {
    renderInvite = () => {
        return (
            <div className="card card-body mb-3">
                <Invite makeRequest={invite} callback={() => this.updateToggle(true)} />
            </div>
        );
    };

    renderMobileSelect = () => {
        const { match, history, location } = this.props;
        const setValue = ({ value }) => history.push(`${match.path}/${value}`);
        const value = location.pathname.split("/").find((item) => pathnames.includes(item));
        return (
            <Select
                label="Выберите страницу"
                options={lists}
                inputProps={{ name: "type" }}
                onChange={setValue}
                value={value}
                unClearable
            />
        );
    };

    renderBody = () => {
        const { match, isAdmin, profile, modal, roles } = this.props;
        return (
            <div>
                {this.renderInvite()}
                <div className="panel__group-tabs">
                    {lists.map(({ label, value }, i, arr) => {
                        const cname = cn("panel panel__tab", { "panel__tab--noborder-right": ++i < arr.length });
                        return (
                            <NavLink
                                key={value}
                                to={`${match.path}/${value}`}
                                className={cname}
                                activeClassName="panel__tab--active"
                            >
                                {label}
                            </NavLink>
                        );
                    })}
                </div>
                <div className="profile__nav-select">{this.renderMobileSelect()}</div>
                <div className="card card-body">
                    <Switch>
                        <Route exact path={`${match.path}/`} render={() => <Redirect to={`${match.path}/members`} />} />
                        <Route
                            exact
                            path={`${match.path}/invited`}
                            render={() => (
                                <List
                                    isAdmin={isAdmin}
                                    profile={profile}
                                    value={userStatesEnum.Invited}
                                    org={profile.organizationId}
                                    action="ban"
                                    modal={modal}
                                    shouldUpdate={this.state.shouldUpdate}
                                    updateToggle={this.updateToggle}
                                    invite
                                />
                            )}
                        />

                        <Route
                            exact
                            path={`${match.path}/members`}
                            render={() => (
                                <List
                                    isAdmin={isAdmin}
                                    profile={profile}
                                    value={userStatesEnum.Valid}
                                    org={profile.organizationId}
                                    action="ban"
                                    modal={modal}
                                    roles={roles}
                                />
                            )}
                        />

                        <Route
                            exact
                            path={`${match.path}/blocked`}
                            render={() => (
                                <List
                                    isAdmin={isAdmin}
                                    profile={profile}
                                    value={userStatesEnum.Banned}
                                    org={profile.organizationId}
                                    action="unban"
                                    modal={modal}
                                    roles={roles}
                                />
                            )}
                        />
                    </Switch>
                </div>
            </div>
        );
    };
}
